/**
 * On the website, a page opened from another (Story Bot, Upload…) leads back
 * to it, "‹ Library", above the page: as the iOS app's back button, which its
 * native header has instead
 */
import * as preact from "preact";

import type { AppRouterLike } from "AppRouter";
import * as nativeHeader from "nativeHeader";
import * as pageTransitions from "pageTransitions";
import Button from "ui/Button";

interface Props {
  pageName: string;
  appRouter: AppRouterLike;
}

export default class PageBackLink extends preact.Component<Props> {
  render() {
    const back = nativeHeader.isEnabled()
      ? undefined
      : pageTransitions.back(this.props.pageName);
    return back ? (
      <Button
        kind="plain"
        class="pageBackLink"
        icon="icon-chevron-left"
        onClick={() => back.go(this.props.appRouter)}
      >
        {back.title}
      </Button>
    ) : null;
  }
}
